// Pure validation functions. Return null when the field is empty/untouched,
// or { valid: bool, message: string } when there is a value to validate.

const ALLOWED_CHARS = /^[a-zA-Z0-9!@#$%^&*()]+$/;

export function validateUsername(value) {
  if (!value) return null;
  if (value.length < 4 || value.length > 14)
    return { valid: false, message: "Username must be between 4 and 14 characters." };
  if (!ALLOWED_CHARS.test(value))
    return { valid: false, message: "Invalid characters in username." };
  return { valid: true, message: "" };
}

export function validatePassword(value) {
  if (!value) return null;
  if (value.length < 6 || value.length > 14)
    return { valid: false, message: "Password must be between 6 and 14 characters." };
  if (!ALLOWED_CHARS.test(value))
    return { valid: false, message: "Invalid characters in password." };
  return { valid: true, message: "" };
}

export function validateConfirmPassword(value, password) {
  if (!value) return null;
  if (value !== password)
    return { valid: false, message: "Passwords do not match." };
  return { valid: true, message: "" };
}

export function validateEmail(value) {
  if (!value) return null;
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
    return { valid: false, message: "Enter a valid email address." };
  return { valid: true, message: "" };
}

// Returns the Bootstrap validation class for a field result.
export function validationClass(result) {
  if (result === null) return "";
  return result.valid ? "is-valid" : "is-invalid";
}
